class RegistrationResponse {
    constructor() {
        this.success = false;
        this.message = '';
        this.organisationId = '';
    }
    static fromApiResponse(response) {
        return {
          success: response.success !== undefined ? response.success : false,
          message: response.message || ''
        };
      }
}
export default RegistrationResponse;